export default __webpack_public_path__ + "static/media/sleeping-dog-with-cloud.5963d513.png";